module.exports = __webpack_public_path__ + "img/90BF486898ED4D84.8c7c9b0e.png";